import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AddDependenciaUsuarioRequest, IGetUsuariosByDependencia } from '../../shared/interfaces/database/seguridad';
import { IGetUsuariosValidos } from '../../shared/interfaces/database/tramite';


@Injectable({
  providedIn: 'root'
})
export class SecDependenciaUsuarioService {
  private readonly baseUrl = `${environment.apiUrl}/api/dependencia-usuario`;

  constructor(private http: HttpClient) { }

  getUsuariosByDependencia(dependenciaId: number): Observable<IGetUsuariosByDependencia[]> {
    return this.http.get<IGetUsuariosByDependencia[]>(`${this.baseUrl}/${dependenciaId}`);
  }

  getUsuariosDisponiblesParaAgregarADependencia(dependenciaId: number): Observable<IGetUsuariosValidos[]> {
    return this.http.get<IGetUsuariosValidos[]>(`${this.baseUrl}/usuarios/${dependenciaId}`);
  }

  addDependenciaUsuario(request: AddDependenciaUsuarioRequest): Observable<string> {
    return this.http.post(`${this.baseUrl}`, request, { responseType: 'text' });
  }

  deleteDependenciaUsuario(dependenciaId: number, usuarioId: number): Observable<string> {
    return this.http.delete(`${this.baseUrl}/${dependenciaId}/${usuarioId}`, { responseType: 'text' });
  }
}
